import React, { useCallback, useContext } from 'react';
import { ILocalizationContext, LocalizationContext } from '../localizationState/localizationContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';

export const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, typeOfModalWindow } = useContext<ILocalizationContext>(LocalizationContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'error' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="errorWhileSaving" />
			)}
		</ModalWrapper>
	);
};
